export function isEmpty(obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) return false;
  }
  return true;
}



// WEBPACK FOOTER //
// ./src/utils/objectChecker.js